import React, { Component } from 'react'
import * as mat from 'material-ui';
import Logo from '../images/Logo.jpg'
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import { connect } from 'react-redux';
import { setCurrentQuiz } from '../../action/playAction';
import firebase from 'firebase';
import YouTube from 'react-youtube'



class KeyDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            players: [],
            gamePinObj: {}
        }
    }
    removedFromList() {
        alert("under working")
    }
    componentDidMount() {
        this.setState({ gamePinObj: this.props.gameKey })
        // console.log(this.props.gameKey, 'fdasfadsfadsfadsfads')
        let that = this;
        firebase.database().ref('/gameRom/').on('child_changed', function (changeData) {
            if (changeData.val().key === that.props.gameKey.key) {
                // console.log('changeData.val()', changeData.val());
                if ('players' in changeData.val()) {
                    that.setState({
                        players: changeData.val().players,
                        gamePinObj: changeData.val()
                    })
                }
            }
        })
    }
    teamClick() {
        // console.log('played', this.state.gamePinObj);
        let gamePinObjClone = this.state.gamePinObj;
        gamePinObjClone.quizStart = true;
        gamePinObjClone.currentQuizIndex = 0;
        firebase.database().ref('/gameRom/' + gamePinObjClone.key + '/').set(gamePinObjClone);
        this.setState({ gamePinObj: gamePinObjClone });
        this.props.setCurrentQuiz(gamePinObjClone);
    }
    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    render() {
        const {
            gameKey,
            playingData
        } = this.props;
        // console.log( this.state.gamePinObj.players,"this.state.gamePinObj.players")
        const opts = {
            height: 700,
            width: '100%',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 0,
                showinfo: false,
                controls: 0,
                wmode: 'opaque',
                rel: 0
            },

        };

        return (
            <div >
            <div className='col-md-12' style={{ opacity: 0.8,height: 'auto', marginTop: '5%' }}>
                <YouTube
                    videoId={playingData}
                    opts={opts}
                    onReady={this._onReady}
                />
            </div>
            <mat.Card
                zDepth={0}
                className='col-md-12 col-xs-12'
                style={{
                    position: 'absolute',
                    left: '0px',
                    top: '8%',
                    zIndex: 2,
                    backgroundColor: 'rgba(255,255,255,1)',
                    // height: 55
                }}
            >
                {/* <div className="page-header text-center">
                    <img src={Logo} alt="Logo" />
                </div> */}
                {/* <div className="text-center">
                    {
                        (gameKey.type && gameKey.type.toLowerCase() === 'team') ? (
                            <p style={{ color: '#ffffff', fontSize: '3.5vh', fontFamily: 'arial', fontWeight: 'normal' }}>{gameKey.type}</p>
                        ) :
                            (
                                <p style={{ color: '#ffffff', fontSize: '3.5vh', fontFamily: 'arial', fontWeight: 'normal' }}>Solo (Player vs Player)</p>
                            )
                    }
                </div> */}
                <mat.Card zDepth={1} style={{ overflow: 'hidden', backgroundColor: 'transparent' }}>
                    <mat.CardHeader
                        title={<p style={{ color: '#000000', fontSize: '5.5vh', fontFamily: 'times new roman', fontWeight: 'bold' }}>{gameKey.key}</p>}
                        subtitleStyle={{ color: 'gray' }}
                        actAsExpander={true}
                        className='text-center'
                        iconStyle={{ color: '#000000' }}
                        showExpandableButton={true}
                        titleStyle={{ fontSize: '2em' }}
                        style={{height: 78}}
                    />
                    <mat.CardText expandable={true}>
                        <mat.Card zDepth={0} className='text-cneter' style={{ marginTop: '2.5%', backgroundColor: 'transparent ' }}>
                            <div className='row'>
                                <div className='col-md-9 col-xs-12'>
                                    <p style={{ color: '#000000', fontSize: '2.5vh', fontFamily: 'cursive', fontWeight: 'bold' }}>
                                        {gameKey.type && gameKey.type.toLowerCase() === 'team' ? gameKey.type : 'Player'}
                                        ({(this.state.gamePinObj && this.state.gamePinObj.players && this.state.gamePinObj.players !== null && Object.keys(this.state.gamePinObj.players).length) ? (Object.keys(this.state.gamePinObj.players).length) : (0)})</p>
                                </div>
                                <div className='col-md-3 col-xs-12 text-center'>
                                    {
                                            (this.state.gamePinObj && this.state.gamePinObj.players && this.state.gamePinObj.players !== null && Object.keys(this.state.gamePinObj.players).length) ?
                                            (
                                                <mat.RaisedButton
                                                    onClick={this.teamClick.bind(this)}
                                                    label='Start'
                                                    primary={true}
                                                    labelStyle={{ color: '#ffffff' }}
                                                />
                                            ) : (
                                                <mat.RaisedButton
                                                    onClick={this.teamClick.bind(this)}
                                                    label='Start'
                                                    primary={true}
                                                    disabled={true}
                                                    labelStyle={{ color: '#ffffff' }}
                                                />
                                            )
                                    }
                                </div>
                            </div>
                        </mat.Card>
                        <mat.Card zDepth={0} style={{ backgroundColor: 'transparent' }}>
                            {
                                    (this.state.gamePinObj && this.state.gamePinObj.players && this.state.gamePinObj.players !== null && Object.keys(this.state.gamePinObj.players).length) ?
                                    (
                                        Object.keys(this.state.gamePinObj.players).map((playerId, ind) => {
                                            var player = this.state.gamePinObj.players[playerId];
                                            return (
                                                <mat.List key={ind}>
                                                    <mat.ListItem
                                                        disabled={true}
                                                        style={{ color: '#000000' }}
                                                        primaryText={player.teamName}
                                                        secondaryText={
                                                            <span style={{ paddingLeft: '5%' }}>

                                                                {
                                                                    (this.state.gamePinObj.type === 'Team') ?
                                                                        (
                                                                            player.playerName.map((v, i) => {
                                                                                return (
                                                                                    <span style={{ color: '#000000' }} key={i}>{v}, </span>
                                                                                )
                                                                            })
                                                                        ) :
                                                                        null
                                                                }
                                                            </span>
                                                        }
                                                    />
                                                </mat.List>
                                            )
                                        })
                                    ) : null
                            }
                        </mat.Card>
                    </mat.CardText>
                </mat.Card>
            </mat.Card>
        </div >
        )
    }
}
const mapStateToProps = (state) => {
    return {
        gameKey: state.PlayReducers.playKey,
        playingData: state.PlayReducers.playingData
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentQuiz: (quizData) => {
            dispatch(setCurrentQuiz(quizData));
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KeyDisplay);
// export default KeyDisplay;


// WEBPACK FOOTER //
// ./src/component/play/keyDisplay.jsx